import React, { useEffect, useState } from 'react';
import './Reservations.css';

const Reservations = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determine which widget to use based on screen size
  const getWidgetSrc = () => {
    if (isMobile) {
      return "//www.yelp.com/reservations/highlands-sports-bar-and-grill-san-carlos/widget?orientation=vertical&color-scheme=dark";
    } else {
      return "//www.yelp.com/reservations/highlands-sports-bar-and-grill-san-carlos/widget?orientation=horizontal&color-scheme=dark";
    }
  };

  return (
    <div className="reservations-container">
      <div className="reservations-content">
        <h1 className="reservations-title">Make a Reservation</h1>
        <p className="reservations-description">
          Ready to join us? Use our reservation widget below to secure your spot at Highlands Sports Bar & Grill.
        </p>
        <div className="widget-container">
          <iframe 
            id="yelp-reservations-widget" 
            frameBorder="0" 
            width="100%" 
            height={isMobile ? "530" : "88"}
            style={{ 
              minHeight: isMobile ? '530px' : '88px', 
              maxHeight: isMobile ? '530px' : '120px',
              border: 'none',
              borderRadius: '0.625rem',
              overflow: 'hidden'
            }}
            src={getWidgetSrc()}
            title="Make a reservation"
          >
            <a href="https://www.yelp.com/reservations/highlands-sports-bar-and-grill-san-carlos">Reserve at Highlands Sports Bar & Grill on Yelp</a>
          </iframe>
        </div>
      </div>
    </div>
  );
};

export default Reservations; 